import PL_utils from '../patterns/pl-utils.js';

/**
 * @file nagifation.js
 *
 * The navigation menu(mobile).
 *
 * On mobile, toggle the navigation menu with navigation trigger
 * On mobile, toggle the sub navigation menus with navigation items.
 * On window resize, reset the menu
 *
 */
const nav = (() => {
  const body = document.querySelector('body');
  const navigation = document.querySelector('.navigation');
  const navLinks = document.querySelectorAll('.nav__link');
  const navItems = document.querySelectorAll('.nav__item');
  const subNavItems = document.querySelectorAll('.subnav__item');
  const navigationTrigger = document.querySelector('.navigation-trigger');
  const fatpTrigger = document.querySelector('.header__zip-search-trigger');
  const backdrop = document.querySelector('.backdrop');

  const openNav = () => {
    PL_utils.addClass('mobile-nav-open', body);
    PL_utils.addClass('active', navigation);
    PL_utils.addClass('active', navigationTrigger);
    navigationTrigger.setAttribute('aria-expanded', 'true');
  };

  const toggleNav = () => {
    const isNavOpen = body.classList.contains('mobile-nav-open');
    const isFatpOpen = body.classList.contains('fatp-nav-open');
    const globalHeaderHeight = document.querySelector('.global-header').offsetHeight;
    const navigation = document.querySelector('.navigation');

    if (isFatpOpen) {
      closeFatp();
    }
    if (isNavOpen) {
      closeNav();
    } else {
      openNav();
      navigation.style.height = `calc( 100vh - ${globalHeaderHeight}px )`;
      document.querySelector('.backdrop').style.height = body.offsetHeight + 'px';
    }
  };

  const toggleFatp = () => {
    const isFatpOpen = body.classList.contains('fatp-nav-open');
    const isNavOpen = body.classList.contains('mobile-nav-open');
    if (isNavOpen) {
      closeNav();
    }
    if (isFatpOpen) {
      closeFatp();
    } else {
      openFatp();
    }
  };

  const closeFatp = () => {
    PL_utils.removeClass('fatp-nav-open', body);
  };

  const openFatp = () => {
    PL_utils.addClass('fatp-nav-open', body);
  };

  const closeNav = () => {
    PL_utils.removeClass('mobile-nav-open', body);
    PL_utils.removeClass('active', navigation);
    PL_utils.removeClass('active', navigationTrigger);
    navigationTrigger.setAttribute('aria-expanded', 'false');
  };

  /**
   * Toggle sub nav when a nav item is been clicked.
   *
   * Need to turn it into function to make sure that the event trigger element `this` is used,
   * instead of the target that's been CLICKED.
   * Reference used on difference between this and e.target on eventListener;
   * https: //javascript.info/bubbling-and-capturing
   */
  function toggleNavLinks(event) {
    if (event.target.href && event.target.href.indexOf('#') > -1) {
      event.preventDefault();
    }

    hideSelectedNav();
    PL_utils.addClass('selected', event.target.parentElement);
    PL_utils.toggleClass('subnav-open', this); // eslint-disable-line no-invalid-this

    if (event.target.classList.contains('subnav-open')) {
      event.target.setAttribute('aria-expanded', 'true');
    }
    else {
      event.target.setAttribute('aria-expanded', 'false');
    }
  }

  function hideSelectedNav() {
    navLinks.forEach((navLinkNode) => {
      if (navLinkNode.parentElement.classList.contains('selected')) {
        PL_utils.removeClass('selected', navLinkNode.parentElement);
        PL_utils.removeClass('subnav-open', navLinkNode);
        navLinkNode.setAttribute('aria-expanded', 'false');
      }
    });
  }




  const closeNavLinks = (node) => {
    PL_utils.removeClass('subnav-open', node);
  };

  const resetNav = () => {
    closeNav();
    navigation.style.height = '100%';
    navLinks.forEach((navLinkNode) => {
      if (navLinkNode.classList.contains('subnav-open')) {
        closeNavLinks(navLinkNode);
      }
    });
  };

  const init = () => {
    const timer = '';
    navigationTrigger.addEventListener('click', (event) => {
      event.preventDefault();
      toggleNav();
    });

    fatpTrigger.addEventListener('click', toggleFatp);

    backdrop.addEventListener('click', closeNav);
    navLinks.forEach((navLinkNode) => {
      navLinkNode.addEventListener('click', toggleNavLinks);
    });

    if (window.innerWidth > 768) {
      const menuItems = document.querySelectorAll('li.has-submenu');
      Array.prototype.forEach.call(menuItems, function (el, i) {
        el.addEventListener('mouseover', function (event) {
          hideSelectedNav();
        });
      });


      document.addEventListener('keyup', function (key) {
        if (key.code == 'Escape') {
          hideSelectedNav();
        }
      });
    }

    window.addEventListener('resize', function(){
      //check if it's still on mobile
      var deviceWidth = window.innerWidth;
      if(deviceWidth > 768){
        resetNav();
      }
    });
    highlightCurrentPage();
  };

  const highlightCurrentPage = () => {
    const bodyClass = document.getElementsByTagName('body')[0].classList;
    const navItems = document.querySelectorAll('.nav__item');
    if (bodyClass.contains('about-opioid') || bodyClass.contains('treating-opioid-addiction')) {
      navItems[0].classList.add('active');
    } else if (bodyClass.contains('why-sublocade') || bodyClass.contains('how-sublocade-works')) {
      navItems[1].classList.add('active');
    } else if (bodyClass.contains('how-to-start') || bodyClass.contains('what-to-expect')) {
      navItems[2].classList.add('active');
    } else if (bodyClass.contains('caregivers')) {
      navItems[3].classList.add('active');
    } else if (bodyClass.contains('savings') || bodyClass.contains('stories') || bodyClass.contains('resources') || bodyClass.contains('faq')) {
      navItems[4].classList.add('active');
    }

    //sub navs
    const navSubItems_1 = navItems[0].querySelectorAll('.subnav__link');
    if (bodyClass.contains('about-opioid')) {
      navSubItems_1[0].classList.add('active');
    } else if (bodyClass.contains('treating-opioid-addiction')) {
      navSubItems_1[1].classList.add('active');
    }


    const navSubItems_2 = navItems[1].querySelectorAll('.subnav__link');
    if (bodyClass.contains('why-sublocade')) {
      navSubItems_2[0].classList.add('active');
    } else if (bodyClass.contains('how-sublocade-works')) {
      navSubItems_2[1].classList.add('active');
    }


    const navSubItems_3 = navItems[2].querySelectorAll('.subnav__link');
    if (bodyClass.contains('how-to-start')) {
      navSubItems_3[0].classList.add('active');
    } else if (bodyClass.contains('what-to-expect')) {
      navSubItems_3[1].classList.add('active');
    }

    const navSubItems_4 = navItems[4].querySelectorAll('.subnav__link');
    if (bodyClass.contains('savings')) {
      navSubItems_4[0].classList.add('active');
    } else if(bodyClass.contains('stories')) {
      navSubItems_4[1].classList.add('active');
    } else if (bodyClass.contains('resources')) {
      navSubItems_4[2].classList.add('active');
    } else if (bodyClass.contains('faq')) {
      navSubItems_4[3].classList.add('active');
    }
  };

  return {
    init,
    openNav
  };
})();


export default () => {
  nav.init();
};
